import * as React from "react";
import styled from "styled-components";
import { PersonBreedJudgeSearchPanel } from "./PersonBreedJudgeSearchPanel";
import { PersonBreedJudgeSavePanel, IPersonBreedJudgeSavePanelProps } from "./PersonBreedJudgeSavePanel";
import { PanelStack, Classes, IPanel } from "@blueprintjs/core";
import { ETLCodes } from "../../../../../locales";
import { useTl } from "../../../../../hooks";
import { BreedGridDto } from "../../../../../api";

export interface IPersonBreedJudgePanelStackProps extends Pick<IPersonBreedJudgeSavePanelProps, "onSaved"> {
  personId: number;
  breedJudgeId: number;
}

const Container = styled.div`
  flex: 1;
  height: 100%;
  & > .${Classes.PANEL_STACK} {
    height: 100%;
  }
`;

export const PersonBreedJudgePanelStack: React.FunctionComponent<IPersonBreedJudgePanelStackProps> = ({
  personId,
  breedJudgeId,
  onSaved,
}) => {
  const { t } = useTl();
  const onSectionSelected = React.useCallback(
    (data: BreedGridDto) => {
      setPanelStack((currentStack) => [
        ...currentStack,
        {
          component: () => <PersonBreedJudgeSavePanel onSaved={onSaved} breed={data} personId={personId} />,
        },
      ]);
    },
    [onSaved, personId]
  );

  const [panelStack, setPanelStack] = React.useState<IPanel[]>([
    {
      component: () =>
        !breedJudgeId ? (
          <PersonBreedJudgeSearchPanel onBreedSelected={onSectionSelected} personId={personId} />
        ) : (
          <PersonBreedJudgeSavePanel onSaved={onSaved} personId={personId} breedJudgeId={breedJudgeId} />
        ),
      title: !breedJudgeId ? t(ETLCodes.BreedSelection) : t(ETLCodes.General_Edit),
    },
  ]);

  const removeFromPanelStack = React.useCallback(() => {
    setPanelStack((prev) => prev.slice(0, prev.length - 1));
  }, [setPanelStack]);

  return (
    <Container>
      <PanelStack stack={panelStack} showPanelHeader={true} onClose={removeFromPanelStack} />
    </Container>
  );
};
